import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';

const formatErrorResponse = async (response) => {
  if (response.status === 409) return 'A tenant with that domain already exists.';
  const text = await response.text().catch(() => '');
  try {
    const body = JSON.parse(text);
    if (typeof body === 'object') {
      const failed = [];
      if (!body.length) failed.push('at least 8 characters');
      if (!body.hasUpperCase) failed.push('an uppercase letter');
      if (!body.hasLowerCase) failed.push('a lowercase letter');
      if (!body.hasNumber) failed.push('a number');
      if (!body.hasSpecialChar) failed.push('a special character (@$!%*?&)');
      if (failed.length) return `Password must contain: ${failed.join(', ')}.`;
    }
  } catch {
    if (text === 'InvalidEmail') return 'Please enter a valid email address.';
    if (text === 'MissingRequiredFields') return 'Please fill in all required fields.';
    if (text) return text;
  }
  return 'Installation failed. Please try again.';
};

const InstallForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    tenantName: '',
    tenantDomain: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
        setError('Passwords do not match');
        return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/install`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        setError(await formatErrorResponse(response));
        return;
      }

      navigate(`/${formData.tenantDomain}/login`);
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <Container className="py-5">
      <Card className="mx-auto" style={{ maxWidth: '500px' }}>
        <Card.Body>
          <Card.Title className="text-center mb-4">Tenant Installation</Card.Title>
          
          {error && (
            <Alert variant="danger">{error}</Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Tenant Name</Form.Label>
              <Form.Control
                type="text"
                name="tenantDomain"
                value={formData.tenantDomain}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Admin Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Admin Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Install Tenant
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default InstallForm;